import { IonFooter, IonRouterLink, IonAvatar, IonCardContent, IonCardTitle, IonCardHeader, useIonViewWillLeave, IonIcon, IonText, IonGrid, IonCol, IonRow, IonImg, IonNote, IonSpinner, useIonViewWillEnter, useIonRouter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { closeSharp, paperPlaneSharp, logoGoogle, logoFacebook } from 'ionicons/icons';
import { Share } from '@capacitor/share';

import './Main.css';

import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';
import NServer, { RegisterAppServices, handleRouteError } from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';
import { hideTab, showTab } from "../components/Tabs";

export interface GamePostProp extends RouteComponentProps<{
    id : any
    }> 
{}


const GamePost : React.FC<GamePostProp> = ({match}) => {

    const [userID, setUserID] = useState(-1);
    const [userName, setUserName] = useState("");
    const [userAvatar, setUserAvatar] = useState("");
    const [image, setImage] = useState("");
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [gameName, setGameName] = useState("");
    const [gameID, setGameID] = useState(-1);
    const [gameIcon, setGameIcon] = useState("../assets/img/fly_pic.png");
    const [userLogin, setUserLogin] = useState(false);
    const [gameBut, setGameBut] = useState("Use App");

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        RegisterAppServices();
        hideTab();

        getData();
    });

    useIonViewWillLeave(() => {
        showTab();
    });

    const getData = async () => {
        let v = new Vault();
        await v.read();

        // check for login
        if (v.account.id < 0)
            setUserLogin(false);
        else
            setUserLogin(true);

        const state = {
            id: v.account.id,
            pass: v.account.key,
            post: match.params.id
        }

        var server = new NServer();
        await server.getList("nc_get_gpost", state);

        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            handleRouteError(router, server.data);
        }
        else
        {
            setImage(server.data.image);
            setTitle(server.data.title);
            setDesc(server.data.desc);

            setUserID(server.data.user_id);
            setUserAvatar(server.data.user_avatar);
            setUserName(server.data.user_name);
            
            setGameID(server.data.game_id);
            setGameName(server.data.game_name);
            setGameIcon(server.data.game_icon);
            setGameBut(server.data.game_but);
        }
	}

    // click on user 
    const onUser = () => {
        if (userID > 20)
            router.push("/user/" + userID, "forward", "push");
    }

    // click on image
    const clickImg = () => {
        router.push("/imgviewer/" + encodeURIComponent(image) + "/0/0/gpost", 
            "forward", "push");
    }

    // send message to iframe
    const doLogin = async () => {
        if (!userLogin)
        {
            router.push("/login", "back", "pop");
        }
    }

    // share outside
    const shareOutside = async () => {
        
        let link = "https://nwallet.me/d/social.php?r=gp" + match.params.id;

        await Share.share({
            title: title,
            text: desc,
            url: link,
            dialogTitle: "Share Post"
        });
    }

    // close the UI
    const closeUI = () => {
        router.push("/mainc", "back", "pop");
    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border">   
                <IonToolbar>
                    <IonTitle className="ion-no-padding">
                        <IonItem className="chat-header" lines="none" color="none">
                            <IonAvatar slot="start">
                                <img src="../assets/img/logo.png" />
                            </IonAvatar>
                            <IonLabel>
                                <b>N-Social</b>
                            </IonLabel>
                            <IonButton slot="end" fill="clear" onClick={closeUI} >
                                <IonIcon slot="icon-only" icon={closeSharp}/>
                            </IonButton>
                        </IonItem>
                    </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                {
                    userID < 0 ?
                <div className="headerCenter">
                    <IonSpinner name="crescent" />
                </div>
                    :
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol id="content-box" size-md="8" size-lg="6" size-xl="5" size-sm="10" size="12">
                             <IonCard className="flat-card ion-no-margin line-margin">
                                <IonItem lines="none">
                                    <IonAvatar className="ub-avt" slot="start" onClick={onUser}>
                                        <img src={userAvatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                                    </IonAvatar>
                                    <IonLabel className="ion-text-wrap">
                                        <h2>
                                            <IonRouterLink color="dark" onClick={onUser}>
                                                <IonText className="item-text"><b>{ userName }</b> <IonText color="medium">{ GetStr(LANGUAGE.TXT_USER_SHARE) }</IonText></IonText>
                                            </IonRouterLink>
                                        </h2>
                                    </IonLabel>
                                </IonItem>

                                <img className="full-post-img" onClick={clickImg} src={image}  onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/con_err.jpg' } } />
                                <IonCardHeader>
                                    <IonCardTitle>{ title }</IonCardTitle>
                                </IonCardHeader>
                                <IonCardContent>
                                    { desc }
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                }
            </IonContent>
            {
                userID < 0 ?
            <div/>
                :
            <IonFooter className="bk2">
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol id="content-box" size-md="8" size-lg="6" size-xl="5" size-sm="10" size="12">
                            {
                                userLogin ?
                            <IonButton className="main-but ion-margin" expand="block" routerLink={ "/gamepage/" + gameID + "/n/n" } >
                                <IonIcon slot="start" icon={paperPlaneSharp} />
                                { gameBut }
                            </IonButton>
                                :
                            <IonButton className="main-but ion-margin" expand="block" onClick={ doLogin }>
                                <IonIcon slot="start" icon={logoGoogle} />
                                { GetStr(LANGUAGE.TXT_GOOGLE_LOGIN) }
                            </IonButton>
                            }
                            <IonButton className="main-but ion-margin" expand="block" color="secondary" onClick={ shareOutside }>
                                <IonIcon slot="start" icon={logoFacebook} />
                                { GetStr(LANGUAGE.TXT_SHARE_POST) }
                            </IonButton>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
            }
        </IonPage>
    );

};

export default GamePost;